import {Component, DestroyRef} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {Observable} from 'rxjs';
import {take} from 'rxjs/operators';
import {FichePreparation} from '../../../@core/models/fichePreparation';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NbToggleModule} from '@nebular/theme';
import {FormsModule} from '@angular/forms';

type BooleanKeys<T> = {
  [K in keyof T]: T[K] extends boolean ? K : never
}[keyof T];

export type FichePreparationBooleanField = BooleanKeys<FichePreparation>;

export interface SwitchButtonParams extends ICellRendererParams<FichePreparation> {
  field: FichePreparationBooleanField;
  update: (value: boolean, id: number) => Observable<unknown>;
  titleOn?: string;
  titleOff?: string;
  canEdit?: boolean;
}

@Component({
  selector: 'ngx-switch-button',
  templateUrl: 'switch-button.component.html',
  styleUrls: ['./switch-button.component.scss'],
  standalone: true,
  imports: [
    NbToggleModule,
    FormsModule,
  ],
})
export class SwitchButtonComponent implements ICellRendererAngularComp {

  protected params: SwitchButtonParams;
  protected data: FichePreparation;

  constructor(private readonly destroyRef: DestroyRef) {}

  agInit(params: SwitchButtonParams): void {
    this.params = params;
    this.data = params.data;
  }

  protected get value(): boolean {
    return this.data[this.params.field];
  }

  protected set value(v: boolean) {
    this.data[this.params.field] = v;
  }

  protected get title(): string {
    return this.value ? (this.params.titleOn ?? '') : (this.params.titleOff ?? '');
  }

  protected onChange(value: boolean): void {
    this.params.update(value, this.data.id).pipe(
      takeUntilDestroyed(this.destroyRef),
      take(1),
    ).subscribe({
      error: () => this.value = !this.value,
    });
  }

  refresh(): boolean {
    return false;
  }
}
